export const experimentalFeatureCheck = (
  experimentalModuleName: string,
  experimentalFeatures: { [key: string]: any }[],
  experimentalFeatureToggleType: number,
  experimentalFeatureName?: string
) =>
  experimentalFeatureName && experimentalFeatures &&
  experimentalFeatures.find(
    (x: any) =>
      x.toggleType === experimentalFeatureToggleType &&
      x.moduleName === experimentalModuleName &&
      x.featureName === experimentalFeatureName
  );